(ns app.domain.requirement.model
  (:require [app.domain.util :as du]
            [core.db.child-entity :as child]))

(def ^{:arglists '([phase-entity])} phase-requirements
  (child/child-entities-of-type-fn :entity.type/requirement))

(defn requested-only-by?
  "True when `review` is the last review still requesting `requirement`."
  [requirement review]
  (= #{(:db/id review)}
     (du/entity-id-set (:review/_requirements requirement))))

(def all-role-requirement-kinds
  #{:requirement.kind/role :requirement.kind/deferred-role})

(defn phase-role-requirements
  ([phase]
   (->> phase
        phase-requirements
        (filter #(all-role-requirement-kinds (:requirement/kind %)))
        set))
  ([phase roles]
   (let [roles (set roles)]
     (->> (phase-role-requirements phase)
          (filter #(contains? roles (:requirement/party-role %)))))))
